<template>
  <div class="MySales panel">
    <h4>My sales</h4>
    <div class="summary">
      <div class="item month">
        <h5>{{ currentMonth }}</h5>
        <div class="value">
          {{ amountCurrentMonth }}
        </div>
        <div :class="salesUpOrDown">
          <Icon
            v-if="monthSalesChange != 0"
            name="arrow"
            :direction="salesUpOrDown" />
          {{ monthSalesChange }}%
        </div>
        <div class="vs">
          versus {{ previousMonth }}
        </div>
      </div>

      <div class="item year">
        <h5>{{ currentYear }}</h5>
        <div class="value">
          {{ amountCurrentYear }}
        </div>
      </div>

      <div class="item last-year">
        <h5>{{ previousYear }}</h5>
        <div class="value">
          {{ amountPreviousYear }}
        </div>
      </div>

      <div class="item total">
        <h5>Total</h5>
        <div class="value">
          {{ amountTotal }}
        </div>
      </div>

      <div class="item hours">
        <h5>Hours</h5>
        <div class="value">
          {{ hours }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "@/axios-client";
import moment from "moment";

export default {
  data: function () {
    return {
      currentYear: moment().format("YYYY"),
      previousYear: moment().subtract(1, "years").format("YYYY"),
      currentMonth: moment().format("MMMM"),
      previousMonth: moment().subtract(1, "months").format("MMMM"),

      amountCurrentYear: 0,
      amountPreviousYear: 0,
      amountCurrentMonth: 0,
      amountPreviousMonth: 0,
      amountTotal: 0,
      currency: "",
      monthSalesChange: 0,
      hours: 0,
    };
  },
  computed: {
    salesUpOrDown() {
      if (this.monthSalesChange === 0) {
        return "";
      }
      return this.monthSalesChange > 0 ? "up" : "down";
    },
  },
  methods: {
    fetchSales() {
      return axios
        .get("/report/dashboard-my-sales")
        .then((response) => response.data.data)
        .then((rows) => {
          rows.forEach((row) => {
            this.amountCurrentYear = row.sales_amount_current_year;
            this.amountPreviousYear = row.sales_amount_previous_year;
            this.amountCurrentMonth = row.sales_amount_current_month;
            this.amountPreviousMonth = row.sales_amount_previous_month;
            this.amountTotal = row.sales_amount_total;
            this.currency = row.currency;
            this.monthSalesChange = row.month_sales_change;
          });
        });
    },
    fetchHours() {
      return axios
        .get("/report/dashboard-hours")
        .then((response) => response.data.data)
        .then((rows) => {
          rows.forEach((row) => {
            this.hours = row.hours;
          });
        });
    },
  },

  mounted() {
    this.fetchSales();
    this.fetchHours();
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/responsive";

.MySales {
  include phone {
    padding: 1em;
  }

  h4,
  h5 {
    text-transform: uppercase;
  }

  .summary {
    flex: 1;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;

    @include phone {
      justify-content: space-evenly;
      flex-wrap: wrap;
      .item {
        padding: 1em;
      }
    }

    > :last-child {
      padding-right: 1em;
    }

    h5 {
      opacity: 0.5;
    }

    .value {
      font-size: 1.25em;
      font-weight: bold;
    }

    .up {
      color: var(--dark-seafoam);
    }

    .down {
      color: var(--pinkish-red);
    }

    .vs {
      font-size: 0.625em;
      opacity: 0.25;
    }
  }
}
</style>
